export const API_URL = process.env.REACT_APP_API_URL;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const MODEL_VERSION = process.env.REACT_APP_MODEL_VERSION;
export const DISABLE_EXPERIMENTAL = process.env.REACT_APP_DISABLE_EXPERIMENTAL !== undefined && process.env.REACT_APP_DISABLE_EXPERIMENTAL === "yes";
export const MAX_UPLOAD_RESOLUTION = process.env.REACT_APP_MAX_UPLOAD_RESOLUTION || 10000;
